import { Link } from 'react-router-dom';
import React, { useState } from 'react';
import { useEmailActions } from 'entities/email/model';
import { toast } from 'react-toastify';
import { triggerFileDownload } from 'shared/lib';
import { useInvoiceActions } from 'entities/invoice/model';
import { Modal } from 'shared/ui/Modal/Modal';
import { Button } from 'shared/ui/Button/Button';

export const SuccessModal: React.FC<{
  invoiceSuccessData: Record<string, any>;
  onClose: () => void;
}> = ({ invoiceSuccessData, onClose }) => {
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const { sendAction } = useEmailActions();
  const { downloadAction } = useInvoiceActions();

  const _handleSendEmail = async () => {
    try {
      setIsSendingEmail(true);
      // @ts-ignore
      await sendAction({
        invoice_data: {
          _id: invoiceSuccessData.id,
          name: invoiceSuccessData.issuerName,
        },
        email: invoiceSuccessData.clientEmail,
      });

      toast.success('Email sent to client');
    } catch (error) {
      toast.error('Sending Email Failed');
      console.error(error);
    } finally {
      setIsSendingEmail(false);
    }
  };

  const _handleInvoiceDownload = async () => {
    try {
      setIsDownloading(true);

      const file = await downloadAction(invoiceSuccessData.id);

      triggerFileDownload(`invoice_${invoiceSuccessData.id}.pdf`, file);
      toast.success('Downloading Success!');
    } catch (error) {
      toast.error('Downloading Failed');
      console.error(error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Modal popup dismissible show={!!invoiceSuccessData} onClose={onClose}>
      <Modal.Header className="dark:border-slate-600"></Modal.Header>

      <Modal.Body>
        <div className="text-center">
          <div className="mx-auto my-4 flex h-24 w-24 items-center justify-center rounded-full bg-gray-700 shadow-md ">
            <span className="p-4 text-6xl">🎊</span>
          </div>
          <div className="my-6 space-y-4 text-center">
            <h3 className="text-2xl font-semibold leading-6 text-white">
              {invoiceSuccessData?.isEditMode
                ? 'Invoice Updated'
                : 'Invoice Created'}
            </h3>

            {!invoiceSuccessData?.isEditMode && (
              <>
                <p className="text-base text-slate-300">
                  You can now send this invoice to{' '}
                  {invoiceSuccessData?.clientEmail
                    ? invoiceSuccessData?.clientEmail
                    : 'your client'}
                  .
                </p>

                <p className="text-base text-slate-300 underline">
                  <a href="#" onClick={_handleInvoiceDownload}>
                    Download Invoice File
                  </a>
                </p>
              </>
            )}

            <div className="flex justify-center p-5">
              <div className="px-2">
                {invoiceSuccessData?.isEditMode ? (
                  <Button
                    color="indigo"
                    isProcessing={isDownloading}
                    onClick={_handleInvoiceDownload}>
                    Download Invoice File
                  </Button>
                ) : (
                  <Button
                    isProcessing={isSendingEmail}
                    color="indigo"
                    onClick={_handleSendEmail}>
                    Send Invoice To Client
                  </Button>
                )}
              </div>

              <div className="px-2">
                <Button
                  color="slate"
                  as={Link}
                  to="/dashboard/invoices"
                  onClick={onClose}>
                  View All Invoices
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
